import { NavLink } from 'react-router-dom'
import { Settings2 } from 'lucide-react'
import { FilesIcon, MemoryIcon, VersionHistoryIcon } from '@/components/icons'
import { cn } from '@/lib/utils'

const sections = [
  { path: 'config', label: 'Config', Icon: Settings2 },
  { path: 'files', label: 'Files', Icon: FilesIcon },
  { path: 'memory', label: 'Memory', Icon: MemoryIcon },
  { path: 'version-history', label: 'Version History', Icon: VersionHistoryIcon },
]

interface AgentSectionsNavProps {
  showMemory: boolean
}

export function AgentSectionsNav({ showMemory }: AgentSectionsNavProps) {
  const visibleSections = showMemory ? sections : sections.filter(section => section.path !== 'memory')

  return (
    <nav className="w-[220px] shrink-0 rounded-2xl border border-border bg-card p-3" aria-label="Agent sections" data-testid="agent-sections-nav">
      <p className="px-2 pb-2 text-sm font-bold leading-[1.6] tracking-[0.015em] text-foreground">Agent sections</p>
      <ul className="space-y-1">
        {visibleSections.map(({ path, label, Icon }) => (
          <li key={path}>
            <NavLink
              to={path}
              className={({ isActive }) =>
                cn(
                  'flex items-center gap-2 rounded-lg px-2 py-2 text-sm transition-colors',
                  isActive ? 'bg-primary font-semibold text-primary-foreground' : 'text-foreground hover:bg-muted',
                )
              }
              data-testid={`agent-section-link-${path}`}
            >
              <Icon className="h-4 w-4 shrink-0" />
              {label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}
